import { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Get from '../../../components/Get'
import Header from '../../../components/Header'
import {
    Box,
    Pagination,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import { VehicleType } from '../../vehicles/types'
import useRouteGuard from '../../../hooks/useRouteGuard'
import { statusOptions } from '../formConfig'

interface VehicleListResponse {
    count: number
    next: string
    previous: string
    results: VehicleType[]
}

const S = {
    View: styled.div`
        padding: 24px;
    `,
}

const RESULTS_PER_PAGE = 10
const RECOVERED_DAYS_AGO = 20

function getDateNDaysAgo(days: number): string {
    const date = new Date()
    date.setDate(date.getDate() - days)
    return date.toISOString().split('T')[0]
}

const RecoveredVehiclesView = () => {
    useRouteGuard(['canReadVehicles'], ['canViewDatabase'])
    const [page, setPage] = useState(1)

    const params = new URLSearchParams({
        status__in: 'not_stolen,seized,recovered',
        date_of_theft__isnull: 'false',
        digitpol_at_seizure: 'false',
        recovered_date__lte: getDateNDaysAgo(RECOVERED_DAYS_AGO),
        ordering: '-date_created',
        offset: `${(page - 1) * RESULTS_PER_PAGE}`,
        limit: `${RESULTS_PER_PAGE}`,
    })
    const url = `/vehicles/?${params.toString()}`

    return (
        <S.View>
            <Header>Recovered Vehicles</Header>
            <Get url={url}>
                {({ data }: { data: VehicleListResponse }) => (
                    <>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" color="text.secondary">
                                Total results: {data.count}
                            </Typography>
                        </Box>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Plate</TableCell>
                                        <TableCell>Make / Model</TableCell>
                                        <TableCell>VIN</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Recovered Date</TableCell>
                                        <TableCell>Recovered Location</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.results?.map((vehicle) => (
                                        <TableRow key={vehicle.id}>
                                            <TableCell>
                                                <Link to={`/vehicles/${vehicle.id}/`}>
                                                    {vehicle.plate}
                                                </Link>
                                            </TableCell>
                                            <TableCell>
                                                {vehicle.make} {vehicle.model}
                                            </TableCell>
                                            <TableCell>{vehicle.vinNumber}</TableCell>
                                            <TableCell>
                                                {statusOptions.find(({ value }) => value === vehicle.status)?.label}
                                            </TableCell>
                                            <TableCell>{vehicle.recoveredDate || '-'}</TableCell>
                                            <TableCell>{vehicle.recoveredLocation || '-'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Pagination
                            sx={{ mt: 2 }}
                            count={Math.ceil(data.count / RESULTS_PER_PAGE)}
                            shape="rounded"
                            onChange={(_, _page) => setPage(_page)}
                            page={page}
                            color="primary"
                            siblingCount={0}
                        />
                    </>
                )}
            </Get>
        </S.View>
    )
}

export default RecoveredVehiclesView
